// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y6Ac","colBig":"styles_colBig__17Y7X","colSmall":"styles_colSmall__2H20Q"};